import { schemaConsorsContactAddressBasic } from './contactAddressBasic.schema';

export const schemaConsorsContactAddressPartner = schemaConsorsContactAddressBasic.strict().refine(
    (data) => {
        if (data.telephoneLandline === undefined && data.telephoneMobile === undefined) return false;
        return true;
    },
    { message: 'telephoneLandline or telephoneMobile must be defined' },
);
